module.exports = __webpack_public_path__ + "static/media/refridgeration-mech.4b6cc02c.jpg";